// AMG engine constants (PSD §0.4 / TODO Task 0.4)
/** CrCl band (±mL/min) around the renal cutoff classifying "borderline" EI eligibility. */
export const BORDERLINE_BAND_ML_MIN = 10;
/** Hartford nomogram valid sampling window (hours after infusion start). */
export const HARTFORD_WINDOW_HR = [6, 14];
/** Default IV infusion duration (minutes). */
export const INFUSION_DEFAULT_MIN = 30;
/** Dose number at which steady state is assumed. */
export const STEADY_STATE_DOSE_THRESHOLD = 3;
/** Adult age floor (years). */
export const ADULT_AGE_FLOOR = 18;
/** Practical dosing intervals (hours) for rounding. */
export const PRACTICAL_INTERVALS_HR = [8, 12, 24, 36, 48];
/** Default amikacin cross-nomogram conversion factor (open Q2 — default 3). */
export const AMIKACIN_CONVERSION_FACTOR_DEFAULT = 3;
//# sourceMappingURL=constants.js.map